<div class="card">
    <img class="icon" src="assets/images/{{number}}.svg" alt="image description" loading="lazy">
    <p class="card-title">{{title}}</p>
    <p class="small-desc">
        {{content}}
    </p>
    <div class="go-corner">
        <div class="go-arrow">{{number}}</div>
    </div>
</div>